module.exports = __webpack_public_path__ + "img/copie-f.c0a82f6b.svg";